import { useCallback, useState } from "react";
import { useReportApi, unwrapReport } from "../api/reportApi";

// Card #2844 -- Score Admin's per-class "which rider score sheets actually
// went out" view. Calls report-api's authed, read-only
// GET /score-sheets/classes/:classId/delivery through the generated client:
// it never creates a sheet-request row and never sends anything, same
// contract as useScoreSheetStatus (the per-ride version of this question).
// Resolves { classId, classPlaced, counts, riders[] }; each rider carries
// `delivery` (SENT | FAILED | HELD | NOT_SENT | NOT_REQUESTED | NO_EMAIL),
// the SES `emailError` for a FAILED one, and the confirmed `sheetEmailedAt`.
// "SENT" means SES accepted the message (it returned a MessageId), not that
// it reached an inbox: bounces are not tracked.
export function useClassSheetDelivery() {
  const reportApi = useReportApi();
  const [loading, setLoading] = useState(false);

  const fetchDelivery = useCallback(
    async (classId) => {
      setLoading(true);
      try {
        const res = await reportApi.riderSheets.getClassSheetDelivery(classId);
        return unwrapReport(res);
      } finally {
        setLoading(false);
      }
    },
    [reportApi],
  );

  return { fetchDelivery, loading };
}

export default useClassSheetDelivery;
